import { RefObject, useState } from "react";
import { Search, X } from "lucide-react";
import { IconButton } from "@clarityos/ui";

interface CommandPaletteInputProps {
  inputRef: RefObject<HTMLInputElement | null>;
  onSearch: (value: string) => void;
  onClear: VoidFunction;
}

export function CommandPaletteInput({
  inputRef,
  onSearch,
  onClear,
}: CommandPaletteInputProps) {
  const [value, setValue] = useState("");

  const handleClear = () => {
    setValue("");
    onClear();
  };

  const handleSearch = () => onSearch(value);

  return (
    <div className="flex items-center gap-3 border-b px-5 py-3.5">
      <Search
        className="text-icon-tertiary size-4.5 shrink-0"
        strokeWidth={2}
      />
      <input
        ref={inputRef}
        autoFocus
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onSearch(value);
          }
        }}
        placeholder="Search patients or navigate..."
        className="typo-title-lg flex-1 border-0 bg-transparent outline-none"
      />
      {value && (
        <IconButton
          size="sm"
          variant="ghost"
          aria-label="clear"
          icon={X}
          onClick={handleClear}
        />
      )}
      <IconButton
        size="sm"
        aria-label="search"
        icon={Search}
        onClick={handleSearch}
      />
    </div>
  );
}
